import { SketchPicker } from 'react-color';
import {
  Box,
} from '@mui/material';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './ColorPicker.scss';

/**
 * Custom color picker for WYSIWYG text editor
 *
 * @export
 * @param {*} props
 */
const defaultProps = {
  onChange: () => {},
  config: {
    popupClassName: '',
    icon: null,
  },
  currentState: {
    color: 'color',
  },
  expanded: false,
  onExpandEvent: () => {},
};
export default function ColorPicker(props) {
  const {
    onChange,
    config,
    currentState,
    expanded,
    onExpandEvent,
  } = { ...defaultProps, ...filterUndefined(props) };
  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  const onChangeComplete = (color) => {
    onChange('color', color.hex);
  };

  const renderModal = () => {
    const { popupClassName } = config;
    const { color } = currentState;
    return (
      <Box
        component='div'
        className={`rdw-colorpicker-modal ${popupClassName}`}
        onClick={stopPropagation}
      >
        <span className='rdw-colorpicker-modal-options'>
          <SketchPicker color={color || 'black'} onChangeComplete={onChangeComplete} />
        </span>
      </Box>
    );
  };

  const { icon } = config;
  return (
    <div
      className='rdw-colorpicker-wrapper'
      aria-haspopup='true'
      aria-expanded={expanded}
      aria-label='rdw-color-picker'
      title='Color Picker'
      data-test='color-picker'
    >
      <Box
        component='div'
        onClick={onExpandEvent}
        className='rdw-option-wrapper bordered-option-classname'
      >
        <img
          src={icon}
          alt=''
        />
      </Box>
      {expanded ? renderModal() : undefined}
    </div>
  );
}
